import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'home',
        component: () => import('../views/home/index.vue'),
        meta: {
            title: '焕己'
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/home/login.vue'),
        meta: {
            title: '焕己'
        }
    },
    {
        path: '/mp',
        name: 'mp',
        component: () => import('../views/mp/index.vue'),
        meta: {
            title: '问卷调查'
        }
    },
    {
        path: '/mp/home',
        name: 'mpHome',
        component: () => import('../views/mp/home.vue'),
        meta: {
            title: '焕己健康管理'
        }
    },
    {
        path: '/mp/native',
        name: 'mpNative',
        component: () => import('../views/mp/native.vue'),
        meta: {
            title: '支付码生成'
        }
    },
    {
        path: '/mp/checkOpenid',
        name: 'mpCheckOpenid',
        component: () => import('../views/mp/checkOpenid.vue'),
        meta: {
            title: '客户授权'
        }
    },
    {
        path: '/mp/weapp-auth',
        name: 'mpWeappAuth',
        component: () => import('../views/mp/weapp-auth.vue'),
        meta: {
            title: '微信授权'
        }
    }, {
        path: '/queue',
        name: 'queue',
        component: () => import('../views/mp/queue.vue'),
        meta: {
            title: '叫号系统'
        }
    }, {
        path: '/com',
        name: 'com',
        component: () => import('../views/com/index.vue'),
        meta: {
            title: '答卷管理'
        }
    },
    {
        path: '/view',
        name: 'view',
        component: () => import('../views/com/view.vue'),
        meta: {
            title: '答卷详情'
        }
    },
    {
        path: '/task',
        name: 'task',
        component: () => import('../views/com/task.vue'),
        meta: {
            title: '待办事项'
        }
    },
    {
        path: '/c/home',
        name: 'cHome',
        component: () => import('../views/custom/index.vue'),
        meta: {
            title: '焕己健康管理'
        }
    },
    {
        path: '/c/question',
        name: 'cQuestion',
        component: () => import('../views/custom/question.vue'),
        meta: {
            title: '问卷'
        }
    },
    {
        path: '/c/queue',
        name: 'cQueue',
        component: () => import('../views/custom/queue.vue'),
        meta: {
            title: '叫号'
        }
    },
    {
        path: '/c/history',
        name: 'cHistory',
        component: () => import('../views/custom/history.vue'),
        meta: {
            title: '历史服务'
        }
    },
    {
        path: '/c/service',
        name: 'cService',
        component: () => import('../views/custom/service.vue'),
        meta: {
            title: '服务'
        }
    },
    {
        path: '/renew-success',
        name: 'renewSuccess',
        component: () => import('../views/mp/renew-success.vue'),
        meta: {
            title: '续费成功'
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 全局前置守卫，用于设置页面标题
router.beforeEach((to, from, next) => {
    // 设置页面标题
    document.title = to.meta.title || '焕己'
    next()
})

export default router